import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import PharmacyProfileSidebar from "../Components/PharmacyProfileSidebar";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { USER_DETAIL } from "../redux/Slices/AuthSlice";
import { pharmcyeditprofileapi } from "../network/Network";

const PharmacyInfo = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state?.Auth?.users);
  const token = useSelector((state) => state?.Auth?.token);
  const [formErrors, setFormErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState("");
  const [getSpecial, setGetSpecial] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [userData, setUserData] = useState({
    first_name: userDetail?.first_name,
    last_name: userDetail?.last_name,
    phone: userDetail?.phone,
    address: userDetail?.address,
    country: userDetail?.country,
    city: userDetail?.city,
    state: userDetail?.state,
    zip_code: userDetail?.zip_code,
    degree_title: userDetail?.degree_title,
    experience: userDetail?.experience,
  });

  const specializationOptions = [
    { value: "pediatrics", label: "Pediatrics" },
    { value: "neurology", label: "Neurology" },
    { value: "adnarology", label: "adnarology" },
    { value: "sharicology", label: "sharicology" },
    { value: "adnarology1", label: "adnarology1" },
    { value: "sharicology1", label: "sharicology1" },
  ];

  const [selectedSpecializations, setSelectedSpecializations] = useState(
    "Area of Specialization"
  );

  const handleChanges = (selectedOptions) => {
    setSelectedSpecializations(selectedOptions);
  };

  //   Input Handler
  function handleChange(e) {
    const value = e.target.value;
    setUserData({ ...userData, [e.target.name]: value });
  }
  // ================

  //   Edit Profile Handler
  const editprofilehandler = (e) => {
    e.preventDefault();
    setLoading(true);
    let isValid = true;
    const errors = {};

    // Validate First Name
    if (!userData || !userData.first_name) {
      if (!errors || !errors.first_name) {
        if (!errors) errors = {};
        errors.first_name = [];
      }
      errors.first_name.push("First Name is required");
      isValid = false;
    }

    // Validate Last Name
    if (!userData || !userData.last_name) {
      if (!errors || !errors.last_name) {
        if (!errors) errors = {};
        errors.last_name = [];
      }
      errors.last_name.push("Last Name is required");
      isValid = false;
    }

    // Validate Phone Number
    if (!userData || !userData.phone) {
      if (!errors || !errors.phone) {
        if (!errors) errors = {};
        errors.phone = [];
      }
      errors.phone.push("Phone is required");
      isValid = false;
    } else if (userData.phone.length < 8 || userData.phone.length > 10) {
      if (!errors || !errors.phone) {
        if (!errors) errors = {};
        errors.phone = [];
      }
      errors.phone.push("Phone number must be between 8 to 10 digits");
      isValid = false;
    }

    // Validate Address
    if (!userData || !userData.address) {
      if (!errors || !errors.address) {
        if (!errors) errors = {};
        errors.address = [];
      }
      errors.address.push("Address is required");
      isValid = false;
    }

    // Validate country
    if (!userData || !userData.country) {
      if (!errors || !errors.country) {
        if (!errors) errors = {};
        errors.country = [];
      }
      errors.country.push("Country is required");
      isValid = false;
    }
    // Validate city
    if (!userData || !userData.city) {
      if (!errors || !errors.city) {
        if (!errors) errors = {};
        errors.city = [];
      }
      errors.city.push("City is required");
      isValid = false;
    }

    // Validate state
    if (!userData || !userData.state) {
      if (!errors || !errors.state) {
        if (!errors) errors = {};
        errors.state = [];
      }
      errors.state.push("State is required");
      isValid = false;
    }

    // Validate zip_code
    if (!userData || !userData.zip_code) {
      if (!errors || !errors.zip_code) {
        if (!errors) errors = {};
        errors.zip_code = [];
      }
      errors.zip_code.push("Zip code is required");
      isValid = false;
    }

    // Validate degree_title
    if (!userData || !userData.degree_title) {
      if (!errors || !errors.degree_title) {
        if (!errors) errors = {};
        errors.degree_title = [];
      }
      errors.degree_title.push("Degree title is required");
      isValid = false;
    }
    // ===================
    // Validate zip_code
    if (!userData || !userData.experience) {
      if (!errors || !errors.experience) {
        if (!errors) errors = {};
        errors.experience = [];
      }
      errors.experience.push("Experience is required");
      isValid = false;
    }
    setFormErrors(errors);

    let data = {
      first_name: userData?.first_name,
      last_name: userData?.last_name,
      phone: userData?.phone,
      address: userData?.address,
      country: userData?.country,
      city: userData?.city,
      state: userData?.state,
      zip_code: userData?.zip_code,
    };

    pharmcyeditprofileapi(userDetail?.id, data, token)
      .then((res) => {
        dispatch(USER_DETAIL(res?.data?.data));
        Swal.fire({
          position: "center",
          icon: "success",
          text: "Congratulations! Your Has Been Update",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate("/pharmacy-perosnal-info");
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });

    setTimeout(() => {
      setFormErrors([]);
    }, 3000);
  };
  // ====================
  return (
    <>
      <Header />
      <PageHeader pagename="Pharmacy Profile" />
      <section className="main-sidebar user-profile">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <PharmacyProfileSidebar />
            </div>
            <div className="col-lg-8">
              <div className="main-profile-content radius-20 p-4">
                <div className="main-headind d-flex align-items-center 	gap-3 mb-3">
                  <div className="edit-btn back">
                    <Link to="/pharmacy-perosnal-info">
                      <div className="nav-anchor">
                        <i className="fa-solid fa-arrow-left"></i>
                      </div>
                    </Link>
                  </div>
                  <h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
                    Edit Personal Info
                  </h5>
                </div>
                <form>
                  <div className="row">
                    <div className="form-group col-lg-12">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Pharmacy A"
                      />
                    </div>
                    <div className="form-group col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        id="firstName"
                        name="first_name"
                        placeholder=" First Name"
                        value={userData?.first_name}
                        onChange={handleChange}
                      />
                      <p className="forms-error">{formErrors?.first_name}</p>
                    </div>
                    <div className="form-group col-lg-6">
                      <input
                        type="text"
                        className="form-control"
                        id="lastName"
                        placeholder=" Last Name"
                        name="last_name"
                        value={userData?.last_name}
                        onChange={handleChange}
                      />
                      <p className="forms-error">{formErrors?.last_name}</p>
                    </div>
                    <div className="form-group col-lg-12">
                      <input
                        type="tel"
                        className="form-control"
                        id="phone"
                        placeholder=" phone number"
                        name="phone"
                        value={userData?.phone}
                        onChange={handleChange}
                      />
                      <p className="forms-error">{formErrors?.phone}</p>
                    </div>
                    <div className="form-group col-lg-12">
                      <input
                        type="text"
                        className="form-control"
                        id="address"
                        placeholder="Address"
                        name="address"
                        value={userData?.address}
                        onChange={handleChange}
                      />
                      <p className="forms-error">{formErrors?.address}</p>
                    </div>
                  </div>
                  <div className="row">
				  <div className="form-group col-lg-3">
                      <input
                        type="text"
                        className="form-control"
                        id="city"
                        placeholder=" City"
                        name="country"
                        value={userData?.country}
                        onChange={handleChange}
                      />
                      <p className="forms-error">{formErrors?.country}</p>
                    </div>
                    <div className="form-group col-lg-3">
                      <input
                        type="text"
                        className="form-control"
                        id="city"
                        placeholder=" City"
                        name="city"
                        value={userData?.city}
                        onChange={handleChange}
                      />
                      <p className="forms-error">{formErrors?.city}</p>
                    </div>
                    <div className="form-group col-lg-3">
                      <input
                        type="text"
                        className="form-control"
                        id="state"
                        placeholder="State"
                        name="state"
                        value={userData?.state}
                        onChange={handleChange}
                      />
                      <p className="forms-error">{formErrors?.state}</p>
                    </div>
                    <div className="form-group col-lg-3">
                      <input
                        type="number"
                        className="form-control"
                        id="zip_code"
                        placeholder=" Zip Code "
                        name="zip_code"
                        value={userData?.zip_code}
                        onChange={handleChange}
                      />
                      <p className="forms-error">{formErrors?.zip_code}</p>
                    </div>
                  </div>
                  <Link className="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none">
                    <span onClick={(e) => editprofilehandler(e)} className="loading-btn loading bg-wrapper ">                    {loading ? <i className="fa fa-spinner"></i> : "Save Changes"}
                    </span>
                  </Link>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PharmacyInfo;
